import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "range" }
const _hoisted_2 = { class: "range__item" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "label-m" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "range__divider" }, "-")
], -1)
const _hoisted_4 = { class: "range__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NInputNumber = _resolveComponent("NInputNumber")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_NInputNumber, {
        "model-value": _ctx.gteValue,
        min: _ctx.angleGteMin,
        max: _ctx.angleGteMax,
        placeholder: `${_ctx.angleGteMin}\xB0`,
        controls: false,
        plain: _ctx.plain,
        clearable: true,
        "onUpdate:modelValue": _ctx.changeHandlerGte
      }, null, 8, ["model-value", "min", "max", "placeholder", "plain", "onUpdate:modelValue"])
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_NInputNumber, {
        "model-value": _ctx.lteValue,
        min: _ctx.angleLteMin,
        max: _ctx.angleLteMax,
        placeholder: `${_ctx.angleLteMax}\xB0`,
        controls: false,
        clearable: true,
        plain: _ctx.plain,
        "onUpdate:modelValue": _ctx.changeHandlerLte
      }, null, 8, ["model-value", "min", "max", "placeholder", "plain", "onUpdate:modelValue"])
    ])
  ]))
}